module.exports = __webpack_public_path__ + "static/media/chia-work-3.48f05122.jpg";